import { createFileRoute, Link } from '@tanstack/react-router';
import { useEffect } from 'react';
import { SEO } from '@/components';
import { FiArrowLeft, FiMail } from 'react-icons/fi';
import { track } from '@/lib/analytics';

// Simple Header for legal pages
function LegalHeader() {
  return (
    <header className='fixed top-0 left-0 right-0 z-50 bg-primary/95 backdrop-blur-sm'>
      <nav className='max-w-7xl mx-auto px-6 py-4'>
        <div className='flex items-center justify-between'>
          <Link to='/' search={{ hero: undefined }} className='text-white text-2xl font-semibold tracking-tight'>
            Harbor
          </Link>
          <Link
            to='/'
            search={{ hero: undefined }}
            className='flex items-center gap-2 text-white/90 hover:text-white transition-colors font-medium'
          >
            <FiArrowLeft />
            Back to Home
          </Link>
        </div>
      </nav>
    </header>
  );
}

const Contact = () => {
  useEffect(() => {
    track('Contact Screen');
  }, []);

  return (
    <div className='bg-white min-h-screen'>
      <SEO
        title='Contact Us | Harbor Co-Parenting App'
        description='Get in touch with the Harbor team. Contact us for support, partnership inquiries, or feedback about our co-parenting app.'
        path='/contact'
      />
      <LegalHeader />
      <div className='pt-24'>
        <div className='max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12 text-left'>
          <header className='mb-12 pb-6 border-b border-gray-200'>
            <h1 className='text-4xl font-bold text-gray-900 mb-2'>Contact Us</h1>
            <p className='text-gray-500 text-sm'>We'd love to hear from you</p>
          </header>

          <div className='space-y-8 text-gray-600 text-left'>
            <p>
              Have questions, feedback, or need assistance with Harbor? We're here to help.
              Reach out to us and we'll get back to you as soon as possible.
            </p>

            <section className='bg-gray-50 rounded-xl p-8'>
              <h2 className='text-2xl font-semibold text-gray-900 mb-6'>Get in Touch</h2>
              
              <div className='flex items-center gap-4'>
                <div className='w-12 h-12 bg-primary/10 rounded-full flex items-center justify-center'>
                  <FiMail className='w-6 h-6 text-primary' />
                </div>
                <div>
                  <p className='text-sm text-gray-500 mb-1'>Email</p>
                  <a 
                    href='mailto:team@harborcoparent.com' 
                    className='text-lg font-medium text-primary hover:underline'
                  >
                    team@harborcoparent.com
                  </a>
                </div>
              </div>
            </section>

            <section>
              <h2 className='text-2xl font-semibold text-gray-900 mb-4 mt-8'>What to Expect</h2>
              <p>
                When you contact us, we typically respond within 1-2 business days. 
                Please include as much detail as possible about your inquiry so we can 
                assist you more effectively.
              </p>
            </section>
          </div>

          <footer className='mt-16 pt-6 border-t border-gray-200 text-left text-gray-400 text-sm'>
            <p>&copy; {new Date().getFullYear()} Harbor. All rights reserved.</p>
          </footer>
        </div>
      </div>
    </div>
  );
};

export const Route = createFileRoute('/contact')({
  component: Contact,
});

